module.exports = __webpack_public_path__ + "img/21b37f84-072a-48a8-ac32-f9e44d9ddf73.65f7a36c.png";